import { Component, Inject } from "@angular/core";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { UserService } from "../../services/user.service"
import { IUser } from "../../interfaces/User";

@Component({
  selector: "register",
  templateUrl: "./register.component.html",
  styleUrls: ['./register.component.css']
})

export class RegisterComponent {
  title: string;
  form: FormGroup;
  data: any;

  constructor(private router: Router,
    private fb: FormBuilder,
    private userService: UserService
  )
  {
    this.title = "New User Registration";
    // initialize the form
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      Username: ['', Validators.required],
      Email: ['',
        [Validators.required,
        Validators.email]
      ],
      IsAdministrator: Boolean ["false"],
      Password: ['', Validators.required],
      PasswordConfirm: ['', Validators.required],
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      Title: [''],
      Company: ['', Validators.required],
      CompanyCode: ['', Validators.required],
      Web: [''],
    }, {
        validator: this.passwordConfirmValidator
      });
  }

  onSubmit() {
    // build a temporary user object from form values
    var tempUser = <IUser>{};
    tempUser.userName = this.form.value.Username;
    tempUser.email = this.form.value.Email;
    tempUser.password = this.form.value.Password;
    tempUser.firstName = this.form.value.FirstName;
    tempUser.lastName = this.form.value.LastName;
    tempUser.title = this.form.value.Title;
    tempUser.company = this.form.value.Company;
    tempUser.companyCode = this.form.value.CompanyCode;
    tempUser.web = this.form.value.Web;
    tempUser.isAdministrator = this.form.value.IsAdministrator === null ? false: true;

    this.userService.putUser(tempUser)
      .subscribe(
        data => {
          this.data = data;
          this.router.navigate(["/show-user"]);
      },
        err => {
          console.error(err);
          this.form.setErrors({
            "register": err.error
          });
      });

  }

  onBack() {
    this.router.navigate(["/home"]);
  }

  passwordConfirmValidator(control: FormControl): any {
    let p = control.root.get('Password');
    let pc = control.root.get('PasswordConfirm');
    if (p && pc) {
      if (p.value !== pc.value) {
        pc.setErrors(
          { "PasswordMismatch": true }
        );
      }
      else {
        pc.setErrors(null);
      }
    }
    return null;
  }

  // retrieve a FormControl
  getFormControl(name: string) {
    return this.form.get(name);
  }

  // returns TRUE if the FormControl is valid
  isValid(name: string) {
    var e = this.getFormControl(name);
    return e && e.valid;
  }

  // returns TRUE if the FormControl has been changed
  isChanged(name: string) {
    var e = this.getFormControl(name);
    return e && (e.dirty || e.touched);
  }

  // returns TRUE if the FormControl is invalid after user changes
  hasError(name: string) {
    var e = this.getFormControl(name);
    return e && (e.dirty || e.touched) && !e.valid;
  }
}
